export const SOCIAL_PROVIDERS = ['zernio', 'buffer'] as const;

export type SocialProviderType = (typeof SOCIAL_PROVIDERS)[number];
